import {fetchDrivers} from "../network/DriverListAPI";

export const DriverListReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const {filters, dispatcher} = action.data;
            fetchDrivers({filters}, dispatcher);
            return {...state, loading: true, success: true};
        case "SET_DATA":
            return {...state, drivers: action.data, filterDrivers: action.data, loading: false, success: true};
        case "FILTER_DATA":
            return {
                ...state, filterDrivers: state.drivers.filter(driver => {
                    return driver.DRIVER_NAME.toLowerCase().includes(action.data.prefix.toLowerCase())
                })
            };
        case "SET_ERROR":
            return {...state, loading: false, success: false};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/reducers/DriverListReducer.js